import Store from "@/store/index.js";
import axios from 'axios';
const domain = Store.state.domain;
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    ValidarDatosExcelCivil(vm) {
        const request = new FormData()
        request.append("datos", JSON.stringify(vm.data))
        return vm.axios.post(`${vm.domain.domainNameForApi}CargaMasiva/ValidarDatosExcelCivil`, request, { timeout: 1000000 }).then(response => response.data)
    },
    async DatosExcelCivil(vm) {
        var request = new FormData()
        request.append("datos", JSON.stringify(vm.data));
        request.append("uslogin", MetodosGenerales.ObtenerUserName());
        let response = await axios.post(`${domain.domainNameForApi}CargaMasiva/DatosExcelCivil`, request);
        return response.data;
    },
    async DescargarWalmart(vm, reportes) {
        var datosReporte = new FormData();
        datosReporte.append("reportes", reportes);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}CargaMasiva/DescargarWalmart`, datosReporte);
        return response.data
    },
    async DescargarTemplateWalmart(vm) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}CargaMasiva/DescargarTemplateWalmart`, { responseType: 'blob', });
        return response.data
    }
}